/* @flow */
import React from 'react';
import ActivitiesClassViewHeaderActionsContainer from 'payments/containers/ActivitiesClassViewHeaderActionsContainer.jsx';

import './styles/ActivitiesClassViewHeader.scss';

class ActivitiesClassViewHeader extends React.Component {
  render() {
    return (
      <div className="ActivitiesClassViewHeader">
        <div className="ActivitiesClassViewHeader-title">
          Activities
        </div>
        <ActivitiesClassViewHeaderActionsContainer />
      </div>
    );
  }
}

export default ActivitiesClassViewHeader;



// WEBPACK FOOTER //
// ./src/payments/components/ActivitiesClassViewHeader.jsx